export const setupStyles = `
.tienda-setup-scope {
  --setup-celeste: #0891b2;
  --setup-celeste-bg: #ecfeff;
  --setup-celeste-border: #a5f3fc;
  --setup-celeste-text: #0e7490;
  --setup-border: #e8ecf1;
  --setup-slate: #64748b;

  width: 100%;
  max-width: 100%;
  height: 100%;
  min-height: 0;
  padding: 0;
  font-family: 'Segoe UI', system-ui, sans-serif;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  min-width: 0;
  overflow: hidden;
}

.tienda-setup-formcard::-webkit-scrollbar {
  width: 10px;
}
.tienda-setup-formcard::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}
.tienda-setup-formcard::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
  border: 2px solid #f1f5f9;
}
.tienda-setup-formcard::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.tienda-setup-formcard {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 #f1f5f9;
}

/* ---------- Cabecera ---------- */
.tienda-setup-header {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 14px;
  flex-shrink: 0;
}

.tienda-setup-kicker {
  display: inline-flex;
  align-self: flex-start;
  align-items: center;
  padding: 3px 10px;
  margin-bottom: 4px;
  border-radius: 999px;
  background: var(--setup-celeste-bg);
  border: 1px solid var(--setup-celeste-border);
  color: var(--setup-celeste-text);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.tienda-setup-title {
  font-size: 24px;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
  line-height: 1.2;
  letter-spacing: -0.02em;
}

.tienda-setup-sub {
  font-size: 14px;
  color: var(--setup-slate);
  margin: 0;
  font-weight: 600;
  max-width: 720px;
  line-height: 1.45;
}

/* ---------- Tabs (control segmentado con iconos) ---------- */
.tienda-setup-tabs {
  display: flex;
  flex-wrap: nowrap;
  gap: 6px;
  margin-bottom: 16px;
  flex-shrink: 0;
  padding: 6px;
  border-radius: 14px;
  border: 1px solid var(--setup-border);
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  overflow-x: auto;
  scrollbar-width: thin;
}

.tienda-setup-tabs::-webkit-scrollbar {
  height: 6px;
}
.tienda-setup-tabs::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 6px;
}

.tienda-setup-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: 1px solid transparent;
  background: transparent;
  color: var(--setup-slate);
  padding: 9px 14px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  font-family: inherit;
  white-space: nowrap;
  transition: background 0.18s, border-color 0.18s, color 0.18s, box-shadow 0.18s;
}

.tienda-setup-tab__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  transition: color 0.18s;
}

.tienda-setup-tab:hover {
  background: #f1f5f9;
  color: #0f172a;
}
.tienda-setup-tab:hover .tienda-setup-tab__icon {
  color: #64748b;
}

.tienda-setup-tab-active,
.tienda-setup-tab-active:hover {
  background: #ffffff;
  color: var(--setup-celeste-text);
  border-color: var(--setup-celeste-border);
  box-shadow: 0 2px 8px rgba(8, 145, 178, 0.14);
}
.tienda-setup-tab-active .tienda-setup-tab__icon {
  color: var(--setup-celeste);
}

/* ---------- Tarjeta de contenido ---------- */
.tienda-setup-formcard {
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  overflow-y: auto;
  overflow-x: hidden;
  background: #ffffff;
  border: 1px solid var(--setup-border);
  border-radius: 16px;
  padding: 22px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

/* ---------- Acciones / botones ---------- */
.tienda-setup-actions {
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
}

.tienda-setup-btn {
  padding: 10px 18px;
  background: var(--setup-celeste);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-weight: 800;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
  font-size: 14px;
  font-family: inherit;
  box-shadow: 0 6px 16px rgba(8, 145, 178, 0.22);
}
.tienda-setup-btn:hover:not(:disabled) {
  background: #0c6f87;
}
.tienda-setup-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

.tienda-setup-msg {
  font-size: 14px;
  margin: 0;
  font-weight: 700;
}
.tienda-setup-msg-ok { color: #065f46; }
.tienda-setup-msg-err { color: #7f1d1d; }

/* ---------- Primitivos de formulario ---------- */
.tienda-setup-grid {
  display: grid;
  gap: 14px;
}

.tienda-setup-field label {
  display: block;
  font-size: 12px;
  font-weight: 800;
  color: #475569;
  margin-bottom: 6px;
  letter-spacing: 0.02em;
}

.tienda-setup-field input,
.tienda-setup-field select,
.tienda-setup-field textarea {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 11px 12px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  font-size: 14px;
  color: #334155;
  background: #f8fafc;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  font-family: inherit;
}
.tienda-setup-field input:focus,
.tienda-setup-field select:focus,
.tienda-setup-field textarea:focus {
  outline: none;
  border-color: var(--setup-celeste-border);
  box-shadow: 0 0 0 3px rgba(8, 145, 178, 0.15);
  background: #fff;
}

.tienda-setup-field textarea {
  min-height: 140px;
  resize: vertical;
  line-height: 1.5;
}

.tienda-setup-rowline {
  border-top: 1px solid #f1f5f9;
  padding-top: 20px;
  margin-top: 12px;
}

.tienda-setup-h3 {
  font-size: 15px;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 14px;
  padding-bottom: 8px;
  border-bottom: 1px solid #eef2f7;
}

.tienda-setup-check {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #334155;
  font-weight: 600;
  cursor: pointer;
}
.tienda-setup-check input {
  width: auto;
  accent-color: var(--setup-celeste);
}

.tienda-setup-empty {
  text-align: center;
  padding: 28px 16px;
  color: #94a3b8;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
}

.tienda-setup-loading {
  padding: 24px;
  text-align: center;
  color: #64748b;
  font-size: 14px;
  font-weight: 700;
}

@media (max-width: 640px) {
  .tienda-setup-title {
    font-size: 21px;
  }
  .tienda-setup-formcard {
    padding: 16px;
  }
  .tienda-setup-tab__label {
    display: none;
  }
  .tienda-setup-tab {
    padding: 9px 12px;
  }
}
`;
